// WicketToggle.jsx
import React, { useState, useEffect } from "react";

const WicketToggle = ({ modelParams }) => {
  const [wicketVisible, setWicketVisible] = useState(true);
  const [windowsVisible, setWindowsVisible] = useState(true);

  const wicket = modelParams?.wicket || null;
  const windows = modelParams?.windows || null;

  useEffect(() => {
    if (wicket) wicket.visible = wicketVisible;
  }, [wicketVisible, wicket]);

  useEffect(() => {
    if (windows) windows.visible = windowsVisible;
  }, [windowsVisible, windows]);

  // хуки уже вызваны — выходим безопасно
  if (!wicket && !windows) return null;

  return (
    <div style={{ display: "flex", gap: "12px", color: "white" }}>
      {wicket && (
        <label style={{ color: "white" }}>
          <input
            type="checkbox"
            checked={wicketVisible}
            onChange={(e) => setWicketVisible(e.target.checked)}
            style={{ marginRight: "5px" }}
          />
          Калитка
        </label>
      )}

      {windows && (
        <label style={{ color: "white" }}>
          <input
            type="checkbox"
            checked={windowsVisible}
            onChange={(e) => setWindowsVisible(e.target.checked)}
            style={{ marginRight: "5px" }}
          />
          Окно
        </label>
      )}
    </div>
  );
};

export default WicketToggle;
